import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ContaService } from '../../shared/service/conta.service';
import { MsgService } from '../../shared/service/msg.service';
import { Conta } from '../../shared/model/conta.model';
import { ModalCadastroContaComponent } from '../modal-cadastro-conta/modal-cadastro-conta.component';

@Component({
  selector: 'app-instagram-callback',
  standalone: true,
  imports: [],
  templateUrl: './instagram-callback.component.html',
  styleUrl: './instagram-callback.component.css'
})
export class InstagramCallbackComponent implements OnInit {

  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly dialog = inject(MatDialog);
  private readonly contaService = inject(ContaService);
  private readonly msgService = inject(MsgService);

  ngOnInit(): void {
    const code = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('state');

    if (!code || !state) {
      this.router.navigate(['/conta']);
      this.msgService.msgErro('O link de autorização é inválido ou expirou. Tente conectar novamente.');
      return;
    }

    this.contaService.processarCallbackInstagram(code, state).subscribe({
      next: conta => {
        this.router.navigate(['/conta']).then(() => {
          this.msgService.msgSucesso('Conta conectada com sucesso!');
          this.abrirModalEdicao(conta);
        });
      },
      error: err => {
        this.router.navigate(['/conta']);
        this.msgService.msgErro(err?.error?.message ?? 'Não foi possível conectar a conta do Instagram.');
      }
    });
  }

  private abrirModalEdicao(conta: Conta) {
    const mobile = window.innerWidth <= 970;
    const dialogRef = this.dialog.open(ModalCadastroContaComponent, {
      width: mobile ? '100%' : '450px',
      maxWidth: mobile ? '100vw' : '450px',
      height: mobile ? '92dvh' : '100dvh',
      maxHeight: mobile ? '92dvh' : '100dvh',
      position: mobile ? { bottom: '0', left: '0' } : { top: '0', right: '0' },
      data: { visualizar: false, conta },
      panelClass: mobile ? 'slide-modal-baixo' : 'slide-modal',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.contaService.salvarEditarNumero(res).subscribe({
          next: () => this.msgService.msgSucesso('Conta salva com sucesso!'),
          error: err => this.msgService.msgErro(err.message)
        });
      }
    });
  }
}
